import React from 'react';
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { UseDispositivosRedeReturn } from './useDispositivosRede';

type DispositivoDeleteDialogProps = Pick<
  UseDispositivosRedeReturn,
  'deleteTarget' | 'setDeleteTarget' | 'handleDelete'
>;

const DispositivoDeleteDialog: React.FC<DispositivoDeleteDialogProps> = ({
  deleteTarget,
  setDeleteTarget,
  handleDelete,
}) => (
  <Dialog open={!!deleteTarget} onClose={() => setDeleteTarget(null)}>
    <DialogTitle sx={{ fontWeight: 700 }}>Excluir dispositivo</DialogTitle>
    <DialogContent>
      <Typography>
        Deseja excluir o dispositivo <strong>{deleteTarget?.nome}</strong>?
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={() => setDeleteTarget(null)}>Cancelar</Button>
      <Button color="error" variant="contained" onClick={handleDelete} sx={{ borderRadius: 2 }}>
        Excluir
      </Button>
    </DialogActions>
  </Dialog>
);

export default DispositivoDeleteDialog;
